<template>
  <!-- begin:: Header Topbar -->
  <div class="topbar">

    <!--begin: Notifications -->
    <router-link :to="{ name: 'Notifications' }">
      <b-button
        v-wave
        size="md"
        variant="light"
        class="position-relative btn-icon mr-3"
        style="z-index: 10;">
        <i
          class="fa fa-bell fa-sm"
          :class="eventsElementsEmpty ? 'text-muted' : 'text-dark-50'"></i>
        <span
          v-if="!eventsElementsEmpty"
          class="topbar-bell position-absolute label label-sm label-rounded"
          :class="[
            { 'label-danger pulse pulse-danger font-weight-bolder' : !eventsElementsEmpty },
            { 'label-light-dark font-weight-bold' : eventsElementsEmpty },
          ]">
          <span class="position-relative">{{ totalEventsElements }}</span>
          <span
            v-if="!eventsElementsEmpty"
            class="pulse-ring"></span>
        </span>
      </b-button>
    </router-link>
    <!--end: Notifications -->

    <!--begin: User -->
    <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip>
      <template v-slot:button-content>
        <div
          class="btn btn-icon w-auto btn-light d-flex align-items-center btn-md pl-0 pl-md-4 pr-md-2"
          v-wave
          id="kt_quick_user_toggle">
          <span
            class="text-muted font-weight-bold font-size-base d-none d-md-inline pr-1">
            Hi,
          </span>
          <span
            class="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
            {{ currentUser.username }}
          </span>
          <span class="symbol symbol-30 symbol-light-dark">
            <span
              v-if="true"
              class="symbol-label font-size-lg font-weight-bold text-white  rounded-sm">
              {{ currentUser.username.charAt(0).toUpperCase() }}
            </span>
          </span>
        </div>
      </template>
      <!-- <b-dropdown-item
        to="/profile"
        class="d-flex align-items-center">
        <span class="">My Profile</span>
      </b-dropdown-item>
      <b-dropdown-item
        to="/settings"
        class="d-flex align-items-center">
        <span class="">Settings</span>
      </b-dropdown-item>
      <b-dropdown-divider></b-dropdown-divider> -->
      <b-dropdown-item
        href="#"
        class="d-flex align-items-center"
        @click="onLogout">
        <span class="text-danger">Sign Out</span>
      </b-dropdown-item>
    </b-dropdown>
    <!--end: User -->
  </div>
  <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;
    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import { LOGOUT } from '@/core/services/store/auth.module'

export default {
  name: 'KTTopbar',
  computed: {
    ...mapGetters([
      'currentUser',
      'totalEventsElements',
      'eventsElementsEmpty'
    ]),
  },
  methods: {
		onLogout() {
			this.$store
			  .dispatch(LOGOUT)
				.then(() => this.$router.push({ name: 'login' }))
        .catch(() => {})
		},
	},
}
</script>
